module.exports = __webpack_public_path__ + "static/media/headphone.be2f31e6.png";